export const CLEANUP_HOW_IT_WORKS_STATE = 'cleanup-how-it-works-state';
const cleanupHowItWorksState = () => ({ type: CLEANUP_HOW_IT_WORKS_STATE });
export default cleanupHowItWorksState;
